import React from 'react';

export default
    <path d="M11.3,5h-8C2.6,5,2,5.6,2,6.2v7.5C2,14.4,2.6,15,3.3,15h8c0.7,0,1.3-0.6,1.3-1.2V6.2C12.7,5.6,12.1,5,11.3,5L11.3,5z
	 M16.6,6l-3,2V12l3,2c0.6,0.4,1.4,0,1.4-0.7V6.7C18,6,17.2,5.6,16.6,6z"/>;
